import { render, staticRenderFns } from "./ClienteDebito.vue?vue&type=template&id=52ba13be&scoped=true"
import script from "./ClienteDebito.vue?vue&type=script&lang=js"
export * from "./ClienteDebito.vue?vue&type=script&lang=js"
import style0 from "./ClienteDebito.vue?vue&type=style&index=0&id=52ba13be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ba13be",
  null
  
)

export default component.exports